// Versão: 1.13
// Data..: 2026-10-14
// Enums e uniões de domínio compartilhados entre backend e frontend.
// v1.13: Tempo de execução (cronômetro) — TicketEventType EXECUTION_TIME/TIMER_PAUSED/
//        TIMER_RESUMED + rótulos (pt-BR) e ícones correspondentes.
// v1.12: Ponto Eletrônico (hora extra) — PunchKindLabels (rótulos pt-BR dos 4 eventos).
// v1.11: Ponto Eletrônico — UserRole.ACCOUNTING (Contabilidade) + UserRoleLabels.
// v1.10: InvoiceStatus + labels (módulo de Faturamento — cobrança/boleto Inter).
// v1.09: evento de auditoria COMPANY_CHANGED (empresa alterada no chamado).
// v1.08: automações — mais campos de condição (cliente, nível, depto, responsável,
// tag, é-tarefa), operadores (não contém, começa com, está/não está entre) e ações
// (encaminhar para nível N1/N2/N3, definir fila/categoria, marcar tarefa).
// Papéis de usuário no portal.
export const UserRole = {
    ADMIN: 'admin', // administrador do portal (Makweb)
    AGENT: 'agent', // atendente / suporte
    CLIENT: 'client', // usuário de uma empresa cliente
    ACCOUNTING: 'accounting', // contabilidade (somente relatórios de ponto)
};
// Rótulos legíveis em pt-BR para os papéis de usuário (selects do painel).
export const UserRoleLabels = {
    admin: 'Administrador',
    agent: 'Atendente',
    client: 'Cliente',
    accounting: 'Contabilidade',
};
// Rótulos legíveis em pt-BR para os tipos de marcação de ponto (4 eventos).
export const PunchKindLabels = {
    ENTRY: 'Entrada',
    LUNCH_START: 'Início do almoço',
    LUNCH_END: 'Volta do almoço',
    EXIT: 'Saída',
};
// Níveis de suporte para escalonamento (N1, N2, N3).
export const SupportLevel = {
    L1: 'L1',
    L2: 'L2',
    L3: 'L3',
};
// Departamentos padrão. Também é possível cadastrar departamentos dinâmicos.
export const DepartmentKind = {
    SUPPORT: 'support', // Suporte
    FINANCE: 'finance', // Financeiro
    SALES: 'sales', // Vendas
};
// Situação (status) de um ticket ao longo do ciclo de vida.
export const TicketStatus = {
    OPEN: 'open', // novo / aberto
    TRIAGE: 'triage', // triagem
    IN_PROGRESS: 'in_progress', // em atendimento
    WAITING_CLIENT: 'waiting_client', // aguardando resposta do cliente
    WAITING_THIRD_PARTY: 'waiting_third_party', // aguardando terceiro
    SCHEDULED: 'scheduled', // agendado
    RESOLVED: 'resolved', // resolvido
    CLOSED: 'closed', // fechado
};
// Impacto do incidente (abrangência).
export const Impact = {
    LOW: 'low', // um usuário
    MEDIUM: 'medium', // uma equipe/setor
    HIGH: 'high', // toda a empresa
};
// Urgência (necessidade de rapidez).
export const Urgency = {
    LOW: 'low',
    MEDIUM: 'medium',
    HIGH: 'high',
};
// Frequência de repetição de uma tarefa recorrente.
export const RecurrenceFreq = {
    DAILY: 'daily',
    WEEKLY: 'weekly',
    MONTHLY: 'monthly',
    YEARLY: 'yearly',
};
export const RecurrenceFreqLabels = {
    daily: 'Diária', weekly: 'Semanal', monthly: 'Mensal', yearly: 'Anual',
};
// Prioridade do ticket.
export const TicketPriority = {
    LOW: 'low',
    NORMAL: 'normal',
    HIGH: 'high',
    URGENT: 'urgent',
};
// Canal de origem do ticket / mensagem.
export const Channel = {
    WEB: 'web',
    EMAIL: 'email',
    WHATSAPP: 'whatsapp',
    SITE_CHAT: 'site_chat',
    MW_SCAN: 'mw_scan',
    PHONE: 'phone', // ligação telefônica (3CX)
};
// Direção de uma mensagem dentro do ticket.
export const MessageDirection = {
    INBOUND: 'inbound', // do cliente para o suporte
    OUTBOUND: 'outbound', // do suporte para o cliente
    INTERNAL: 'internal', // nota interna, não visível ao cliente
};
// Visibilidade de um artigo da base de conhecimento.
export const ArticleVisibility = {
    PUBLIC: 'public', // visível a qualquer pessoa
    PRIVATE: 'private', // visível apenas a agentes/admin
};
// Tipo de contrato/plano de suporte da empresa cliente.
export const ContractType = {
    HOURS_BANK: 'hours_bank', // banco de horas (horas contratadas/mês)
    UNLIMITED: 'unlimited', // suporte ilimitado (fee fixo)
    PER_CALL: 'per_call', // por chamado/avulso
    MANAGED: 'managed', // serviço gerenciado (MSP completo)
};
// Tipo de ativo do inventário (CMDB).
export const AssetType = {
    SERVER: 'server',
    WORKSTATION: 'workstation',
    NOTEBOOK: 'notebook',
    NETWORK: 'network', // switch, roteador, firewall
    PRINTER: 'printer',
    MOBILE: 'mobile',
    SOFTWARE: 'software', // licença/aplicação
    OTHER: 'other',
};
// Situação operacional de um ativo.
export const AssetStatus = {
    ACTIVE: 'active', // em uso
    INACTIVE: 'inactive', // desativado
    MAINTENANCE: 'maintenance', // em manutenção
    RETIRED: 'retired', // descartado
};
// Tipo de evento na timeline/auditoria do chamado.
export const TicketEventType = {
    CREATED: 'created',
    STATUS_CHANGED: 'status_changed',
    PRIORITY_CHANGED: 'priority_changed',
    ASSIGNED: 'assigned',
    CATEGORY_CHANGED: 'category_changed',
    COMPANY_CHANGED: 'company_changed',
    MESSAGE_PUBLIC: 'message_public',
    MESSAGE_INTERNAL: 'message_internal',
    FIRST_RESPONSE: 'first_response',
    RESOLVED: 'resolved',
    REOPENED: 'reopened',
    MERGED: 'merged',
    SLA_PAUSED: 'sla_paused',
    SLA_RESUMED: 'sla_resumed',
    SLA_BREACHED: 'sla_breached',
    ASSET_LINKED: 'asset_linked',
    FOLLOWER_ADDED: 'follower_added',
    FOLLOWER_REMOVED: 'follower_removed',
    TIME_LOGGED: 'time_logged',
    APPROVAL_REQUESTED: 'approval_requested',
    APPROVAL_DECIDED: 'approval_decided',
    CHECKLIST_UPDATED: 'checklist_updated',
    AUTOMATION_APPLIED: 'automation_applied',
    VISIT_SCHEDULED: 'visit_scheduled',
    SURVEY_SENT: 'survey_sent',
    SURVEY_ANSWERED: 'survey_answered',
    EXECUTION_TIME: 'execution_time', // tempo de execução acumulado (cronômetro automático)
    TIMER_PAUSED: 'timer_paused', // pausa manual do cronômetro ("Pausa Atendente")
    TIMER_RESUMED: 'timer_resumed', // retomada do cronômetro após pausa manual
};
// Alvo de SLA (para marcar violação de 1ª resposta ou de resolução).
export const SlaTarget = {
    FIRST_RESPONSE: 'first_response',
    RESOLUTION: 'resolution',
};
// Situação de uma solicitação de aprovação em um chamado.
export const ApprovalStatus = {
    PENDING: 'pending',
    APPROVED: 'approved',
    REJECTED: 'rejected',
};
// Gatilho de uma regra de automação (o "QUANDO").
export const AutomationTrigger = {
    TICKET_CREATED: 'ticket_created',
    STATUS_CHANGED: 'status_changed',
    PRIORITY_CHANGED: 'priority_changed',
};
// Campo avaliado nas condições da regra (o "SE"). Cada valor é o nome de uma
// propriedade do Ticket, avaliada diretamente pelo motor de automação.
export const ConditionField = {
    PRIORITY: 'priority',
    STATUS: 'status',
    CATEGORY: 'categoryId',
    COMPANY: 'companyId',
    REQUESTER: 'requesterId', // cliente/solicitante que abriu o chamado
    CHANNEL: 'channel',
    SUBJECT: 'subject',
    DEPARTMENT: 'departmentId',
    SUPPORT_LEVEL: 'supportLevel', // nível atual (N1/N2/N3)
    ASSIGNEE: 'assigneeId', // responsável atual
    TAG: 'tags', // alguma tag do chamado (avaliação especial: array)
    IS_TASK: 'isTask', // é tarefa (true/false)
};
// Operador de comparação da condição.
export const ConditionOperator = {
    EQ: 'eq',
    NEQ: 'neq',
    CONTAINS: 'contains',
    NOT_CONTAINS: 'not_contains',
    STARTS_WITH: 'starts_with',
    IN: 'in', // está em uma lista separada por vírgula (ex.: várias empresas)
    NOT_IN: 'not_in', // não está na lista
};
// Tipo de ação executada pela regra (o "FAÇA").
export const ActionType = {
    ASSIGN: 'assign', // atribuir a um agente (value = userId)
    SET_STATUS: 'set_status', // mudar status (value = status)
    SET_PRIORITY: 'set_priority', // mudar prioridade (value = priority)
    SET_DEPARTMENT: 'set_department', // definir departamento (value = departmentId)
    SET_SUPPORT_LEVEL: 'set_support_level', // rotear para o nível N1/N2/N3 (value = SupportLevel)
    SET_QUEUE: 'set_queue', // definir fila (value = queueId)
    SET_CATEGORY: 'set_category', // definir categoria (value = categoryId)
    ADD_TAG: 'add_tag', // adicionar tag (value = tag)
    MARK_TASK: 'mark_task', // marcar/desmarcar como tarefa (value = 'true'|'false')
    NOTIFY: 'notify', // notificar no Discord (value = mensagem)
};
// Situação de um lançamento financeiro (contas a receber/pagar) da GestãoClick.
export const FinanceStatus = {
    OPEN: 'open', // em aberto (não liquidado, ainda dentro do vencimento)
    PAID: 'paid', // confirmado/liquidado
    OVERDUE: 'overdue', // em atraso (não liquidado e vencido)
};
// Situação de uma visita técnica.
export const VisitStatus = {
    SCHEDULED: 'scheduled',
    DONE: 'done',
    CANCELED: 'canceled',
};
// Matriz Impacto × Urgência → Prioridade (padrão ITIL simplificado).
export function calcPriority(impact, urgency) {
    const score = (v) => (v === 'high' ? 3 : v === 'medium' ? 2 : 1);
    const total = score(impact) + score(urgency); // 2..6
    if (total >= 6)
        return TicketPriority.URGENT;
    if (total >= 5)
        return TicketPriority.HIGH;
    if (total >= 3)
        return TicketPriority.NORMAL;
    return TicketPriority.LOW;
}
// Rótulos legíveis em pt-BR para status/prioridade/impacto/urgência.
export const StatusLabels = {
    open: 'Aberto',
    triage: 'Triagem',
    in_progress: 'Em atendimento',
    waiting_client: 'Aguardando cliente',
    waiting_third_party: 'Aguardando terceiro',
    scheduled: 'Agendado',
    resolved: 'Resolvido',
    closed: 'Fechado',
};
export const PriorityLabels = {
    low: 'Baixa', normal: 'Normal', high: 'Alta', urgent: 'Urgente',
};
export const ImpactLabels = {
    low: 'Baixo (1 usuário)', medium: 'Médio (setor)', high: 'Alto (empresa)',
};
export const UrgencyLabels = {
    low: 'Baixa', medium: 'Média', high: 'Alta',
};
export const ContractTypeLabels = {
    hours_bank: 'Banco de horas',
    unlimited: 'Suporte ilimitado',
    per_call: 'Por chamado',
    managed: 'Serviço gerenciado',
};
export const AssetTypeLabels = {
    server: 'Servidor',
    workstation: 'Estação de trabalho',
    notebook: 'Notebook',
    network: 'Rede',
    printer: 'Impressora',
    mobile: 'Dispositivo móvel',
    software: 'Software/Licença',
    other: 'Outro',
};
export const AssetStatusLabels = {
    active: 'Ativo',
    inactive: 'Inativo',
    maintenance: 'Manutenção',
    retired: 'Descartado',
};
export const TicketEventLabels = {
    created: 'Chamado aberto',
    status_changed: 'Status alterado',
    priority_changed: 'Prioridade alterada',
    assigned: 'Responsável definido',
    category_changed: 'Categoria alterada',
    company_changed: 'Empresa alterada',
    message_public: 'Mensagem enviada',
    message_internal: 'Nota interna',
    first_response: 'Primeira resposta',
    resolved: 'Resolvido',
    reopened: 'Reaberto',
    merged: 'Chamados mesclados',
    sla_paused: 'SLA pausado',
    sla_resumed: 'SLA retomado',
    sla_breached: 'SLA estourado',
    asset_linked: 'Ativo vinculado',
    follower_added: 'Seguidor adicionado',
    follower_removed: 'Seguidor removido',
    time_logged: 'Horas apontadas',
    approval_requested: 'Aprovação solicitada',
    approval_decided: 'Aprovação decidida',
    checklist_updated: 'Checklist atualizado',
    automation_applied: 'Automação aplicada',
    visit_scheduled: 'Visita agendada',
    survey_sent: 'Pesquisa enviada',
    survey_answered: 'Pesquisa respondida',
    execution_time: 'Tempo de execução',
    timer_paused: 'Pausa Atendente',
    timer_resumed: 'Cronômetro retomado',
};
// Ícone (emoji) por tipo de evento — usado na timeline do frontend.
export const TicketEventIcons = {
    created: '📌',
    status_changed: '🔄',
    priority_changed: '⚑',
    assigned: '👤',
    category_changed: '🏷',
    company_changed: '🏢',
    message_public: '💬',
    message_internal: '🔒',
    first_response: '⚡',
    resolved: '✅',
    reopened: '↩',
    merged: '🔗',
    sla_paused: '⏸',
    sla_resumed: '▶',
    sla_breached: '⏰',
    asset_linked: '🖥',
    follower_added: '➕',
    follower_removed: '➖',
    time_logged: '⏱',
    approval_requested: '📝',
    approval_decided: '✔',
    checklist_updated: '☑',
    automation_applied: '🤖',
    visit_scheduled: '📍',
    survey_sent: '📨',
    survey_answered: '⭐',
    execution_time: '⌛',
    timer_paused: '⏸',
    timer_resumed: '▶',
};
// Rótulos de situação de aprovação.
export const ApprovalStatusLabels = {
    pending: 'Pendente',
    approved: 'Aprovado',
    rejected: 'Reprovado',
};
// Rótulos de automação e visita.
export const AutomationTriggerLabels = {
    ticket_created: 'Quando o chamado é aberto',
    status_changed: 'Quando o status muda',
    priority_changed: 'Quando a prioridade muda',
};
export const ConditionFieldLabels = {
    priority: 'Prioridade',
    status: 'Status',
    categoryId: 'Categoria',
    companyId: 'Empresa',
    requesterId: 'Cliente (solicitante)',
    channel: 'Canal',
    subject: 'Assunto',
    departmentId: 'Departamento',
    supportLevel: 'Nível atual (N1/N2/N3)',
    assigneeId: 'Responsável',
    tags: 'Tag',
    isTask: 'É tarefa',
};
export const ConditionOperatorLabels = {
    eq: 'é igual a',
    neq: 'é diferente de',
    contains: 'contém',
    not_contains: 'não contém',
    starts_with: 'começa com',
    in: 'está entre',
    not_in: 'não está entre',
};
export const ActionTypeLabels = {
    assign: 'Atribuir ao agente',
    set_status: 'Definir status',
    set_priority: 'Definir prioridade',
    set_department: 'Definir departamento',
    set_support_level: 'Encaminhar para nível (N1/N2/N3)',
    set_queue: 'Definir fila',
    set_category: 'Definir categoria',
    add_tag: 'Adicionar tag',
    mark_task: 'Marcar como tarefa',
    notify: 'Notificar (Discord)',
};
// Rótulos dos níveis de suporte (para selects de automação e UI).
export const SupportLevelLabels = {
    L1: 'N1', L2: 'N2', L3: 'N3',
};
// Rótulos dos canais de origem.
export const ChannelLabels = {
    web: 'Web', email: 'E-mail', whatsapp: 'WhatsApp', site_chat: 'Chat do site',
    mw_scan: 'MW-SCAN', phone: 'Telefone',
};
export const VisitStatusLabels = {
    scheduled: 'Agendada',
    done: 'Concluída',
    canceled: 'Cancelada',
};
// Rótulos de situação financeira (contas a receber/pagar).
export const FinanceStatusLabels = {
    open: 'Em aberto',
    paid: 'Confirmado',
    overdue: 'Em atraso',
};
// Canal de disparo da cobrança automática.
export const BillingChannel = {
    WHATSAPP: 'whatsapp',
    EMAIL: 'email',
};
export const BillingChannelLabels = {
    whatsapp: 'WhatsApp',
    email: 'E-mail',
};
// Situação de uma fatura/cobrança do módulo de Faturamento (fonte própria, não é a
// NFS-e da GestãoClick). O boleto é emitido no Banco Inter (API Cobrança v3).
export const InvoiceStatus = {
    DRAFT: 'draft', // criada; boleto ainda não emitido (toggle off ou emissão pendente)
    ISSUED: 'issued', // boleto emitido no Inter (a receber)
    PAID: 'paid', // baixa confirmada (liquidado)
    OVERDUE: 'overdue', // vencida e não paga (derivado por data; não é estado persistido)
    CANCELED: 'canceled', // cancelada
};
export const InvoiceStatusLabels = {
    draft: 'Rascunho',
    issued: 'Emitida',
    paid: 'Paga',
    overdue: 'Vencida',
    canceled: 'Cancelada',
};
// Origem de uma fatura: recorrente (gerada de um contrato) ou avulsa (pontual).
export const InvoiceOriginLabels = {
    contract: 'Contrato (recorrente)',
    manual: 'Avulsa',
};
//# sourceMappingURL=enums.js.map